<script>
  /* eslint-disable no-underscore-dangle */

  import { escapeRegExp } from 'lodash';
  import leBubble from '../le-bubble/le-bubble';

  export default {
    name: 'le-text-with-highlight',
    components: {
      leBubble,
    },
    props: {
      text: {
        type: String,
        required: true,
      },
      highlightText: {
        type: [String, RegExp],
        default: '',
      },
      minSearchCharacters: {
        type: Number,
        default: 1,
      },
    },
    render() {
      const vm = this;
      // This component was rewritten with render function to improve it's performance and render span tags only for highlighted text
      // Reference on functions used can be found here: https://github.com/vuejs/vue/blob/4d4d22a3f6017c46d08b67afe46af43027b06629/src/core/instance/render-helpers/index.js
      return vm.$createElement(
        'div',
        { staticClass: 'le-text-with-highlight' },
        [
          vm._l(vm.splitStrings, splitString => splitString.text && (splitString.highlight ?
            vm.$createElement('span', { class: ['text', 'highlight'] }, [vm._v(splitString.text)]) :
            vm._v(splitString.text))),
        ],
      );
    },
    computed: {
      /**
       * Returns this.text splits by this.highlightText. Supporting lower and upper cases
       * @returns {*}
       */


      splitStrings() {
        let splitTexts = [];
        if (this.text && this.highlightText && (this.highlightText.length >= this.minSearchCharacters || this.highlightText instanceof (RegExp))) {
          const reg = this.highlightText instanceof (RegExp) ?
            this.highlightText : new RegExp(`(${escapeRegExp(this.highlightText)})`, 'gim');
          splitTexts = this.text.split(reg).map((val, i) => (i % 2 === 0 ? {
            text: val,
          } : {
            text: val,
            highlight: true,
          }));
        }
        return splitTexts.length > 0 ? splitTexts : [{ text: this.text }];
      },
    },
  };
</script>

<style lang="scss" scoped>
  .le-text-with-highlight {
    display: inline-block;
    word-break: break-word;
    word-wrap: break-word;
    white-space: pre-wrap;
    .text {
      vertical-align: middle;
      &.highlight {
        @include themify {
          background-color: getColor('highlightText');
        }
      }
    }
  }
</style>
